__turbopack_context__.v({
  "details": "ProjectTeaser-module-scss-module__uMjtya__details",
  "preview": "ProjectTeaser-module-scss-module__uMjtya__preview",
  "wrapper": "ProjectTeaser-module-scss-module__uMjtya__wrapper",
});
